import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconCheck.tsx
const OutlinedFilledCheck = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z" })
});
const OutlinedCheck = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z" })
});
const RoundedFilledCheck = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m378-358 350-349q14.36-14 34.18-14T796-706.95q14 14.06 14 33.8 0 19.75-14 34.15L412-256q-14.36 14-34.18 14T344-256L164-436q-14-14.47-14-34.23Q150-490 164.05-504q14.06-14 33.8-14 19.75 0 34.15 14l146 146Z" })
});
const RoundedCheck = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m378-358 350-349q14.36-14 34.18-14T796-706.95q14 14.06 14 33.8 0 19.75-14 34.15L412-256q-14.36 14-34.18 14T344-256L164-436q-14-14.47-14-34.23Q150-490 164.05-504q14.06-14 33.8-14 19.75 0 34.15 14l146 146Z" })
});
const SharpFilledCheck = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z" })
});
const SharpCheck = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z" })
});
const componentMap = {
	outlined: OutlinedCheck,
	"outlined-fill": OutlinedFilledCheck,
	rounded: RoundedCheck,
	"rounded-fill": RoundedFilledCheck,
	sharp: SharpCheck,
	"sharp-fill": SharpFilledCheck
};
const IconCheck = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconCheck };